import React from "react";
import { useLocation } from "react-router-dom";
import Card from "components/Card";
import { Menu, Title, Item } from "./styles";

const SettingsNav = () => {
  
  const { pathname } = useLocation();

  const MENU_ITEMS = [
    {
      title: "Rate Plan",
      to: "/settings/rate-plan",
    },
    {
      title: "Coupon Code",
      to: "/settings/coupon-code",
    },
    {
      title: "Room Type Configuration",
      to: "/settings/room-type-configuration",
    },
    {
      title: "Room Configuration",
      to: "/settings/room-configuration",
    },
    {
      title: "Hotel Info & Policies",
      to: "/settings/hotel-info-and-policies",
    },
    {
      title: "Hotel Charges",
      to: "/settings/hotel-charges",
    },
    {
      title: "Hotel Amenities",
      to: "/settings/hotel-amenities",
    },
    {
      title: "Devices",
      to: "/settings/devices",
    },
    {
      title: "Kiosks",
      to: "/settings/kiosks",
    },
    {
      title: "Banned Vehicles",
      to: "/settings/banned-vehicles",
    },
  ];

  return (
    <Card>
      <Menu>
        <Title>SETTINGS</Title>
        {MENU_ITEMS.map((item, index) => {
          const { title, to } = item;
          return (
            <React.Fragment key={index}>
              {
                <>
                  <Item
                    desktop={title === "HOME"}
                    active={to === pathname}
                    to={to}
                  >
                    {title}
                  </Item>
                </>
              }
            </React.Fragment>
          );
        })}
      </Menu>
    </Card>
  );
};

export default SettingsNav;
